import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntityToCfCampaignBanner } from './mapper';

export class CfCampaignBanner {
    static contentType = contentTypes.CfCampaignBanner;

    static mapCfEntity = mapCfEntityToCfCampaignBanner;

    constructor(props = {}) {
        const {
            title,
            text,
            textColor,
            ctaColor,
            image,
            mobileImage,
            cta,
            ctaBehaviour,
            backgroundColor,
            carouselImage,
            carouselDesktopImage,
            carouselTabletImage,
            carouselMobileImage,
            backgroundType,
        } = props;
        this.data = {
            title,
            text,
            textColor,
            ctaColor,
            image,
            mobileImage,
            cta,
            ctaBehaviour,
            backgroundColor,
            carouselImage,
            carouselDesktopImage,
            carouselTabletImage,
            carouselMobileImage,
            backgroundType,
        };
    }
}
